import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Form} from '../../components/CodeGroup/Form/Form';
import {useCreateCodes} from '../../hooks/codes';
import {useViewer} from '../../hooks/auth';
import {getPermissions} from '../../helpers/roles';

export const CreateCode = () => {
  const createData = useCreateCodes();
  const navigate = useNavigate();
  const user = useViewer();
  const {isAssociate, isDeptManager} = getPermissions();

  return (
    <Form
      mode={'create'}
      formData={createData}
      navigate={navigate}
      user={user}
      isAssociate={isAssociate}
      isDeptManager={isDeptManager}
    />
  );
};
